import React, { useState } from 'react'

import SponsorBadge from 'components/ad_types/SponsorBadge'

import './Header.scss'

const Header = ({ headerImage, isMobileApp, league, status, details, type }) => {
    const darkModeCheck = window.matchMedia('(prefers-color-scheme: dark)')
    const darkImage = details?.broadcast?.[0]?.black_image_url
    const whiteImage = details?.broadcast?.[0]?.image_url
    const mobileAppClass = isMobileApp ? 'mobile_app' : ''
    const isNotPostGame = status !== 'Final'
    const isBroadcast = details?.hasOwnProperty('broadcast') && details?.broadcast?.length > 0
    const isChannelID =
        details?.broadcast?.[0]?.name !== 'sn now+' &&
        details?.broadcast?.[0]?.name !== 'Sportsnet+ Premium'
    const isTV = isNotPostGame && isBroadcast && isChannelID
    const [showToolTip, setShowToolTip] = useState(false)

    const handleMouseEnter = () => {
        if (type === "Pre-Season") setShowToolTip(true)
    }

    const handleMouseLeave = () => {
        if (type === "Pre-Season") setShowToolTip(false)
    }

    return (
        <div className={`Header__Cont ${mobileAppClass} ${league}-livetracker`}>
            <div className="left-col">
                <div className="header-left-col">
                    <div className={type === "Pre-Season" ? "logo__cont_ps" : "logo__cont"} >
                        <img className={type === "Pre-Season" ? "logo_ps" : "logo"} src={headerImage} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} />
                    </div>
                </div>

                <div className="header-middle-col">
                    <div className="sponsor__cont">
                        <SponsorBadge targetMode="adUnit" />
                    </div>
                </div>

                <div className="header-right-col">
                    {isTV && (
                        <div className="tv__cont">
                            TV:
                            <img
                                src={darkModeCheck?.matches ? whiteImage : darkImage} //TODO: - handle this in CSS?
                                style={{
                                    top: !details?.broadcast?.[0]?.name.includes('sn') && '-1px',
                                }}
                            />
                        </div>
                    )}
                </div>

                {showToolTip && type === "Pre-Season" && (
                    <div className="tool_tip">
                        <div className="tool_tip_inner_container">
                            <span className="tooltip_text">Some Live Tracker statistical data might not be available for pre-regular season games.</span>
                        </div>
                    </div>
                )}

            </div>
            <div className="right-col" />
        </div>
    )
}

export default Header
